// extracted by mini-css-extract-plugin
export var dividerLine = "_7v-3";
export var itemImage = "_7v-9";
export var lightDivider = "_7v-4";
export var modalContent = "_7v-5";
export var modalContentCompact = "_7v-6";
export var productCard = "_7v-a";
export var productImage = "_7v-b";
export var productImageCompact = "_7v-7";
export var productImagePlaceholder = "_7v-c";
export var productImagePlaceholderCompact = "_7v-8";
export var progressBarBackground = "_7v-1";
export var progressBarContainer = "_7v-0";
export var progressBarFill = "_7v-2";